export const getLabels = () => {
  const mixPanelLabels = {
    CREATE_CASE_BUTTON_CLICK: 'CREATE_CASE_BUTTON_CLICK',
    CREATE_CASE_MODAL_OPEN: 'CREATE_CASE_MODAL_OPEN',
    CREATE_CASE_AND_SCHEDULE_INSPECTION: 'CREATE_CASE_AND_SCHEDULE_INSPECTION',
    CREATE_CASE_SEARCH_LOCATION: 'CREATE_CASE_SEARCH_LOCATION',
    CREATE_CASE_LOCATION_SUGGESTION_SELECT: 'CREATE_CASE_LOCATION_SUGGESTION_SELECT',
    CREATE_CASE_MAP_DROP_PIN: 'CREATE_CASE_MAP_DROP_PIN',
    CREATE_CASE_MAP_ZOOM_CHANGE: 'CREATE_CASE_MAP_ZOOM_CHANGE',
    CREATE_CASE_MAP_PAN_EVENT: 'CREATE_CASE_MAP_PAN_EVENT',
    CREATE_CASE_MAP_USER_LOCATION_CHANGE: 'CREATE_CASE_MAP_USER_LOCATION_CHANGE',
    CREATE_CASE_MAP_GOTO_CITY_CENTER: 'CREATE_CASE_MAP_GOTO_CITY_CENTER',
    CREATE_CASE_LOCATION_CUSTOM_FIELDS_CLICK: 'CREATE_CASE_LOCATION_CUSTOM_FIELDS_CLICK',
    CREATE_CASE_EDIT_LOCATION: 'CREATE_CASE_EDIT_LOCATION',
    CREATE_CASE_SEARCH_VIOLATION: 'CREATE_CASE_SEARCH_VIOLATION',
    CREATE_CASE_EDIT_ISSUE_DESCRIPTION: 'CREATE_CASE_EDIT_ISSUE_DESCRIPTION',
    CREATE_CASE_ADD_ISSUE_DESCRIPTION: 'CREATE_CASE_ADD_ISSUE_DESCRIPTION',
    CREATE_CASE_SEARCH_CONTACT: 'CREATE_CASE_SEARCH_CONTACT',
    CREATE_CASE_ADD_CONTACT_CLICK: 'CREATE_CASE_ADD_CONTACT_CLICK',
    CREATE_CASE_CREATE_NEW_CONTACT_SUBMIT: 'CREATE_CASE_CREATE_NEW_CONTACT_SUBMIT',
    CREATE_CASE_CREATE_EDIT_CONTACT_SUBMIT: 'CREATE_CASE_CREATE_EDIT_CONTACT_SUBMIT',
    CREATE_CASE_BILL_TO_CONTACT_CLICK: 'CREATE_CASE_BILL_TO_CONTACT_CLICK',
    CREATE_CASE_CONTACT_ROLE_UPDATED: 'CREATE_CASE_CONTACT_ROLE_UPDATED',
    CREATE_CASE_EDIT_CONTACT_CLICK: 'CREATE_CASE_EDIT_CONTACT_CLICK',
    CREATE_CASE_ADD_ATTACHMENT_CLICK: 'CREATE_CASE_ADD_ATTACHMENT_CLICK',

    CREATE_CASE_ADD_ATTACHMENT_PHOTO_NAME_UPDATED: 'CREATE_CASE_ADD_ATTACHMENT_PHOTO_NAME_UPDATED',
    CREATE_CASE_ADD_ATTACHMENT_PHOTO_DESCRIPTION_UPDATED: 'CREATE_CASE_ADD_ATTACHMENT_PHOTO_DESCRIPTION_UPDATED',
    CREATE_CASE_EDIT_ATTACHMENT_PHOTO_NAME_UPDATED: 'CREATE_CASE_EDIT_ATTACHMENT_PHOTO_NAME_UPDATED',
    CREATE_CASE_EDIT_ATTACHMENT_PHOTO_DESCRIPTION_UPDATED: 'CREATE_CASE_EDIT_ATTACHMENT_PHOTO_DESCRIPTION_UPDATED',
    CREATE_CASE_CUSTOM_TILE_FIELD_UPDATED: 'CREATE_CASE_CUSTOM_TILE_FIELD_UPDATED',
    CREATE_CASE_CASEASSIGNEE_UPDATED: 'CREATE_CASE_CASEASSIGNEE_UPDATED',
    CREATE_CASE_INSPECTIONASSIGNEE_UPDATED: 'CREATE_CASE_INSPECTIONASSIGNEE_UPDATED',
    CREATE_CASE_INSPECTION_DATE_UPDATED: 'CREATE_CASE_INSPECTION_DATE_UPDATED',
    CASE_DETAIL_MODAL_OPEN: 'CASE_DETAIL_MODAL_OPEN',
    USER_LOGGED_IN: 'USER_LOGGED_IN',
    AGENCY_REPORTS_TAB: 'AGENCY_REPORTS_TAB',
    AGENCY_CLP_TAB: 'AGENCY_CLP_TAB',
    AGENCY_CRM_TAB: 'AGENCY_CRM_TAB',
    AGENCY_DASHBOARD_TAB: 'AGENCY_DASHBOARD_TAB',
    DASHBOARD_NOTICES_PRINT_QUEUE_WIDGET: 'DASHBOARD_NOTICES_PRINT_QUEUE_WIDGET',
    DASHBOARD_ALL_STAFF_OPEN_CASES_WIDGET: 'DASHBOARD_ALL_STAFF_OPEN_CASES_WIDGET',
    DASHBOARD_ALL_STAFF_TOTAL_CASES_WIDGET: 'DASHBOARD_ALL_STAFF_TOTAL_CASES_WIDGET',
    DASHBOARD_ALL_STAFF_OVERDUE_INSPECTIONS_WIDGET: 'DASHBOARD_ALL_STAFF_OVERDUE_INSPECTIONS_WIDGET',
    DASHBOARD_ALL_STAFF_INSPECTIONS_DUE_TODAY_WIDGET: 'DASHBOARD_ALL_STAFF_INSPECTIONS_DUE_TODAY_WIDGET',
    DASHBOARD_ALL_STAFF_TOTAL_INSPECTIONS_WIDGET: 'DASHBOARD_ALL_STAFF_TOTAL_INSPECTIONS_WIDGET',
    DASHBOARD_SELF_OPEN_CASES_WIDGET: 'DASHBOARD_SELF_OPEN_CASES_WIDGET',
    DASHBOARD_SELF_TOTAL_CASES_WIDGET: 'DASHBOARD_SELF_TOTAL_CASES_WIDGET',
    DASHBOARD_SELF_OVERDUE_INSPECTIONS_WIDGET: 'DASHBOARD_SELF_OVERDUE_INSPECTIONS_WIDGET',
    DASHBOARD_SELF_INSPECTIONS_DUE_TODAY_WIDGET: 'DASHBOARD_SELF_INSPECTIONS_DUE_TODAY_WIDGET',
    DASHBOARD_SELF_TOTAL_INSPECTIONS_WIDGET: 'DASHBOARD_SELF_TOTAL_INSPECTIONS_WIDGET',
    DASHBOARD_ESCALATED_NOTICE_WIDGET: 'DASHBOARD_ESCALATED_NOTICE_WIDGET',
    CREATE_SUBMISSION_BUTTON_CLICK: 'CREATE_SUBMISSION_BUTTON_CLICK',
    SUBMISSION_CREATED_EMAIL_SENT: 'SUBMISSION_CREATED_EMAIL_SENT',
    SUBMISSION_CREATED_TEXT_SENT: 'SUBMISSION_CREATED_TEXT_SENT',
    MANUAL_EMAIL_SENT_FROM_CRM: 'MANUAL_EMAIL_SENT_FROM_CRM',
    TRANSLATION_PREVIEW_COMPLETED: 'TRANSLATION_PREVIEW_COMPLETED',
    MANUAL_EMAIL_SENT_FROM_CEM: 'MANUAL_EMAIL_SENT_FROM_CEM',
    TASK_CREATED: 'TASK_CREATED',
    TAGS_CREATED: 'TAGS_CREATED',
    ASSIGNEE_CHANGED: 'ASSIGNEE_CHANGED',
    SUBMISSION_CLOSED: 'SUBMISSION_CLOSED',
    INTERNAL_COMMENT_ADDED: 'INTERNAL_COMMENT_ADDED',
    SESSION_START_FOR_CRM: 'SESSION_START_FOR_CRM',
    SESSION_END_FOR_CRM: 'SESSION_END_FOR_CRM',
    ELEVIO_APP_LAUNCH: 'ELEVIO_APP_LAUNCH',
    ACTION_CENTER_LOOKUP_COMPLETED: 'ACTION_CENTER_LOOKUP_COMPLETED',
    ACTION_CENTER_SUBMISSION_STARTED: 'ACTION_CENTER_SUBMISSION_STARTED',
    ACTION_CENTER_SUBMISSION_CREATED: 'ACTION_CENTER_SUBMISSION_CREATED',
    // Names are the product events from the Text a Photo architecture, not the usual code labels.
    TEXT_A_PHOTO_SECTION_OPENED: 'Opened Text a Photo section',
    TEXT_A_PHOTO_PROMO_SHOWN: 'Text a Photo promo shown',
    TEXT_A_PHOTO_PROMO_CLICKED: 'Text a Photo promo clicked',
    TEXT_A_PHOTO_PROMO_DISMISSED: 'Text a Photo promo dismissed',
  };

  return mixPanelLabels;
};
